import * as apiMobilePayments from '@/network/api/mobilePayments.api.js'

/** Validate Merchant
@return { promise } - Validate Mobile Payment Merchant Status for a company client
*/
export const validateMobileMerchantStatus = async (context, payload) => {
    const res = await apiMobilePayments.validateMobileMerchantStatus()

    return res
}

/**
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetmobile-paymentsmerchant
@return {promise} - Create a merchant
*/
export const createMobilePaymentMerchant = async (context, payload) => {
	const res = await apiMobilePayments.createMobilePaymentMerchant(payload)

	return res
}